/* @generated */
// prettier-ignore
export const collations = ["big5han","compat","dict","direct","ducet","emoji","eor","gb2312","phonebk","phonetic","pinyin","reformed","search","searchjl","standard","stroke","trad","unihan","zhuyin"] as const
export type Collation = (typeof collations)[number]
